module.exports = __webpack_public_path__ + "img/ico-operacao.29039056.png";